import Ncs from 'ncs';

function groupMultiSelectConfig(field) {
  return {filters: [field], getValues: v => [[v]]}
}

const groupsConfig = {
  'ncs_documents.autor': groupMultiSelectConfig('ncs_documents.autor'),
  'ncs_documents.lustro': {
    filters: ['ncs_documents.ano_publicacion_from', 'ncs_documents.ano_publicacion_to'],
    getValues: v => v.split('-'),
    sortBy: v => !v ? null : parseInt(v.split('-').pop())
  },
  'ncs_documents.titulo_columna': groupMultiSelectConfig('ncs_documents.titulo_columna'),
  'ncs_documents.lugar_publicacion': groupMultiSelectConfig('ncs_documents.lugar_publicacion'),
  'ncs_documents.periodico': groupMultiSelectConfig('ncs_documents.periodico'),
}

const frequency_group_order = []
const metapresOrders = []

const matchingExpressionsConfig = {
  tokens: {
    groups: ['token', 'tag', 'lemma', 'unit', 'category']
  },
  groups: groupsConfig,
  frequency_group_order,
  order: {
    orders: [
      {name: 'matching', criteria: Ncs.utils.matchingOrder(5, true)},
      {name: 'elements', criteria: [{field: 'matching_expressions.elements', asc: false}]},
    ],
  },
}

export default {
  elements: {
    types: ['units', 'tokens', 'documents']
  },
  categories: {
    patterns: {
      A: 'A*',
      C: 'C*',
      D: 'D*',
      N: 'N*',
      P: 'P*',
      R: 'R*',
      SP: 'SP',
      V: 'V*',
      Z: 'Z*',
      F: 'F',
      I: 'I',
      W: 'W',
    }
  },
  filters: {
    values: gon.values,
    dependencyValues: gon.dependencyValues
  },
  result: {
    defaultType: 'kwic',
    types: ['documents', 'frequency', 'full_frequency', 'kwic', 'matching_expressions'],
    detailTypes: ['context', 'document'],
    error: {
      contactLink: './contact',
      contactEmail: 'support@nlpgo.com'
    },
    kwic: {
      order: {
        orders: [...Ncs.utils.defaultOrder(5), ...metapresOrders],
      },
    },
    full_frequency: {
      groups: groupsConfig,
      frequency_group_order,
    },
    matching_expressions: matchingExpressionsConfig,
    context: {
      tokens: {sourceText: true}
    },
    documents: {
      endpoint: 'documents',
      defaultDisplay: 'documents',
      elements: {
        types: ['documents'],
        defaultType: 'documents',
      },
      distances: false,
      order: {
        orders: [],
        default: [],
      },
      pagination: true
    },
    document: {
      endpoint: 'document',
      elements: {
        types: ['documents'],
        defaultType: 'documents',
      },
    }
  },
  download: {
    kwic: {
      header: false
    }
  }
}
